import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates, TransactionType } from 'globals/types';
import { formatDate, getCurrency } from 'globals/utils';
import { FsExpenditureTableTransactionRowDataProps } from 'ui-elements/tables/FsExpenditureTable/FsExpenditureTableTransactionRow/FsExpenditureTableTransactionRow';
import {
  SingleTransactionProps,
  SingleTransaction,
} from './single-transaction';

export interface TransactionsProps {
  data: SingleTransactionProps[];
  max_per_page?: number;
  page?: number;
  pages?: number;
  status: LoadingState;
}

export const Transactions = types
  .model({
    data: types.optional(types.array(SingleTransaction), []),
    max_per_page: types.maybe(types.number),
    page: types.maybe(types.number),
    pages: types.maybe(types.number),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: TransactionsProps): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        ...props,
      };
      applySnapshot(self, newSnapshot);
    },
    updateStatus(status: LoadingState): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        status,
      };
      applySnapshot(self, newSnapshot);
    },
  }))
  .views((self) => ({
    getTransactionArray(): Array<FsExpenditureTableTransactionRowDataProps> {
      return self.data.map(
        ({
          name,
          booking_date_time,
          status,
          id,
          amount,
          balance,
          category,
        }) => ({
          name,
          date: formatDate(booking_date_time, true),
          description: 'lorem ipsum dolor...',
          balance: `${amount}%`,
          value: balance.amount,
          displayValue: getCurrency({ value: balance.amount }),
          tag: status,
          id,
          category,
          type:
            amount >= 0 ? TransactionType.INCOME : TransactionType.EXPENDITURE,
        })
      );
    },
    getPaginationInfo(): {
      itemsPerPage?: number;
      currentPage?: number;
      numberOfPages?: number;
    } {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const { page, pages, max_per_page } = self;
      return {
        itemsPerPage: max_per_page,
        currentPage: page,
        numberOfPages: pages,
      };
    },
  }));

export type TransactionsSnapshot = SnapshotIn<typeof Transactions>;
export type TransactionsInstance = Instance<typeof Transactions>;
